import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
// import LoadingOverlay from 'react-loading-overlay';
import routeConstants from 'routeConstants';

import Guidelines from 'modules/UserManagementAndSecurityModule/Guidelines';
import checkFormat from 'modules/UserManagementAndSecurityModule/checkFormat';
import { ConfirmPassword } from 'modules/UserManagementAndSecurityModule/Input/ConfirmPassword';
import { Password } from 'modules/UserManagementAndSecurityModule/Input/Password';
import '../Screens.css';
import userConstants from 'modules/UserManagementAndSecurityModule/userConstants';
import SideHeader from '../../SideHeader/SideHeader';
import { CommonButtons, WSpinner, WBreadCrumb } from '../../../../common';
import { inputChangedHandler, inputValidityHandler } from '../../FormUtils';
import {encrypt} from '../../../../utils';
import styles from '../../UserManagementStyles';
import data from './data';

// const assignObj = (obj) => { return obj; };
const role =  localStorage.getItem('role');
const breadCrumbValues = [
  { name: 'Home', url: role==='Member' ? '/accountholder': '/accountguestview' },
  { name: 'Profiles & Preferences', url: '/Profile' },
  { name: 'Security Preferences', url: '/SecurityPreferences' },
  { name: 'Change Sign In Credentials', url: '/reset-password' }
];

class CreatePassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      upperLower: false, min: false, symbol: false, numeral: false,
      cancelled: false,
      formIsValid: false,
      form: {
        currentPassword: {
          value: '',
          errMsg: null,
          valid: false,
          label: 'Current Password',
          rules: {
            required: true
          }
        },
        password: {
          value: '',
          errMsg: null,
          valid: false,
          label: 'Password',
          rules: {
            // minLength: 8,
            maxLength: 50,
            pattern: userConstants.passwordRegex,
            patternMessage: userConstants.passwordMessage,
            required: true
          }
        },
        confirmPassword: {
          value: '',
          errMsg: null,
          valid: false,
          label: 'Confirm Password',
          rules: {
            equal: true,
            equalMessage: 'Both passwords do not match',
            required: true
          }
        }
      },
      loading: false
    };
    this.onBack = this.onBack.bind(this);

    this.onNext = this.onNext.bind(this);
  
    this.onChange = this.onChange.bind(this);
  
    this.onBlur = this.onBlur.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    const { loginState, history, changePassword } = props;
    const updatedState = { ...state };
    if (loginState.changePassword) {
        if (loginState.changePassword.errorCode === 0) {
          // console.log(loginState.changePassword)
            history.push({
                  pathname: '/SecurityPreferences',
                  message: {message:'Your password has been successfully changed'}
              });
        } else if (loginState.changePassword.errorCode === 2013) {
          updatedState.form.currentPassword.errMsg = userConstants.passwordError
        } else {
          updatedState.form.currentPassword.errMsg = userConstants.passwordError
        }
        changePassword('');
    }

    return updatedState;
}

  onChange(event, fieldId) {
    checkFormat(event, fieldId, this);
    inputChangedHandler(event, fieldId, this);
  }

  onBlur(fieldId) { inputValidityHandler(fieldId, this); }

  onBack() {
    this.setState((state) => ({ ...state, cancelled: true }));
  }



  onNext() {
    const { form } = this.state;
    const { changePassword, setJWTToken } = this.props;
    const accessToken = localStorage.getItem('accessToken');
    const idToken = localStorage.getItem('token');
    if (idToken) {
        setJWTToken(idToken);
    }
    (async () => {
      const newPassEncrypt = await encrypt(form.password.value);
      const oldPassEncrypt = await encrypt(form.currentPassword.value);

      const payload = {
        accessToken,
        "newPassword": newPassEncrypt,
        "oldPassword": oldPassEncrypt
      };
      // console.log("payload:" +payload);
      changePassword(payload);
    })(); 
    

    //   history.push({
    //     pathname: '/SecurityPreferences',
    //     message: {message:'Your password has been successfully changed'}
    // })
  }

  render() {
    const { form, cancelled, formIsValid } = this.state;
    const {loginState} = this.props;

    return (
      <div>
        <WSpinner loading={loginState.isLoading} />
        {/* <LoadingOverlay active={loginState.isLoading} spinner
          styles={assignObj({
            wrapper: {
              overflow: 'hidden'
            }
          })} /> */}
        <div className="container">
        <WBreadCrumb breadCrumbItems={breadCrumbValues} activeCrumb="Reset Password" />
          <Row className="main">
            <Col md lg xl>
              <SideHeader
                title={data.title} />
                <Guidelines state={this.state} type="password" />
            </Col>
            <Col md lg xl>
              <ConfirmPassword
                id="currentPassword"
                confirmPasswordState={form.currentPassword}
                changed={this.onChange}
                blurred={this.onBlur}
                label="Enter Current Password" />
                <Password
                  passwordState={form.password}
                  changed={this.onChange}
                  blurred={this.onBlur}
                  showStrength
                  label="Enter New Password" />
              <ConfirmPassword
                confirmPasswordState={form.confirmPassword}
                changed={this.onChange}
                blurred={this.onBlur}
                label="Confirm New Password" />
            </Col>
          </Row>
        </div>
        <CommonButtons backClick={this.onBack} submit="true" submitClick={this.onNext} disabled={!formIsValid} blockstyle={styles.commonButtonsHalf} ariabacklabel="Back to Reset Password" />
        {cancelled ? <Redirect to={routeConstants.securityPreferences} /> : null}
      </div>
    );
  }
}

CreatePassword.propTypes = {
  changePassword: PropTypes.func,
  setJWTToken: PropTypes.func,
  loginState: PropTypes.instanceOf(Object),
  history: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.instanceOf(Object)]),
}

CreatePassword.defaultProps = {
  changePassword: () => {},
  setJWTToken: () => {},
  loginState: {},
  history: []
}

export default CreatePassword;